import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import it from "./locales/it.json";
import en from "./locales/en.json";
// Importa i nuovi file dei progetti
import projectsIT from "./locales/projects.it.json";
import projectsEN from "./locales/projects.en.json";

i18n.use(initReactI18next).init({
  resources: {
    it: {
      translation: it,
      projects: projectsIT, // Aggiungiamo il namespace 'projects'
    },
    en: {
      translation: en,
      projects: projectsEN, // Aggiungiamo il namespace 'projects'
    },
  },
  lng: localStorage.getItem("lang") || "it",
  fallbackLng: "it",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("lang", lng);
});

export default i18n;
